// Generated by scripts/gen-cupertino-icons.mjs from Flutter's CupertinoIcons. Do not edit.
export const CUPERTINO_CODEPOINTS = {
  add: 0xf489,
  add_circled: 0xf48a,
  add_circled_solid: 0xf48b,
  airplane: 0xf4d4,
  alarm: 0xf4d5,
  alarm_fill: 0xf4d6,
  alt: 0xf4d7,
  ant: 0xf4d8,
  ant_circle: 0xf4d9,
  ant_circle_fill: 0xf4da,
  ant_fill: 0xf4db,
  antenna_radiowaves_left_right: 0xf4dc,
  app: 0xf4dd,
  app_badge: 0xf4de,
  app_badge_fill: 0xf4df,
  app_fill: 0xf4e0,
  archivebox: 0xf4e1,
  archivebox_fill: 0xf4e2,
  arrow_2_circlepath: 0xf4e3,
  arrow_2_circlepath_circle: 0xf4e4,
  arrow_2_circlepath_circle_fill: 0xf4e5,
  arrow_2_squarepath: 0xf4e6,
  arrow_3_trianglepath: 0xf4e7,
  arrow_branch: 0xf4e8,
  arrow_clockwise: 0xf49a,
  arrow_clockwise_circle: 0xf49b,
  arrow_clockwise_circle_fill: 0xf49c,
  arrow_counterclockwise: 0xf21c,
  arrow_counterclockwise_circle: 0xf4e9,
  arrow_counterclockwise_circle_fill: 0xf4ea,
  arrow_down: 0xf35d,
  arrow_down_circle: 0xf4eb,
  arrow_down_circle_fill: 0xf4ec,
  arrow_down_doc: 0xf4ed,
  arrow_down_doc_fill: 0xf4ee,
  arrow_down_left: 0xf4ef,
  arrow_down_left_circle: 0xf4f0,
  arrow_down_left_circle_fill: 0xf4f1,
  arrow_down_left_square: 0xf4f2,
  arrow_down_left_square_fill: 0xf4f3,
  arrow_down_right: 0xf4f4,
  arrow_down_right_arrow_up_left: 0xf37d,
  arrow_down_right_circle: 0xf4f5,
  arrow_down_right_circle_fill: 0xf4f6,
  arrow_down_right_square: 0xf4f7,
  arrow_down_right_square_fill: 0xf4f8,
  arrow_down_square: 0xf4f9,
  arrow_down_square_fill: 0xf4fa,
  arrow_down_to_line: 0xf4fb,
  arrow_down_to_line_alt: 0xf4fc,
  arrow_left: 0xf4fd,
  arrow_left_circle: 0xf4fe,
  arrow_left_circle_fill: 0xf4ff,
  arrow_left_right: 0xf500,
  arrow_left_right_circle: 0xf501,
  arrow_left_right_circle_fill: 0xf502,
  arrow_left_right_square: 0xf503,
  arrow_left_right_square_fill: 0xf504,
  arrow_left_square: 0xf505,
  arrow_left_square_fill: 0xf506,
  arrow_left_to_line: 0xf507,
  arrow_left_to_line_alt: 0xf508,
  arrow_merge: 0xf509,
  arrow_right: 0xf50a,
  arrow_right_arrow_left: 0xf50b,
  arrow_right_arrow_left_circle: 0xf50c,
  arrow_right_arrow_left_circle_fill: 0xf50d,
  arrow_right_arrow_left_square: 0xf50e,
  arrow_right_arrow_left_square_fill: 0xf50f,
  arrow_right_circle: 0xf510,
  arrow_right_circle_fill: 0xf511,
  arrow_right_square: 0xf512,
  arrow_right_square_fill: 0xf513,
  arrow_right_to_line: 0xf514,
  arrow_right_to_line_alt: 0xf515,
  arrow_swap: 0xf516,
  arrow_turn_down_left: 0xf517,
  arrow_turn_down_right: 0xf518,
  arrow_turn_left_down: 0xf519,
  arrow_turn_left_up: 0xf51a,
  arrow_turn_right_down: 0xf51b,
  arrow_turn_right_up: 0xf51c,
  arrow_turn_up_left: 0xf51d,
  arrow_turn_up_right: 0xf51e,
  arrow_up: 0xf366,
  arrow_up_arrow_down: 0xf51f,
  arrow_up_arrow_down_circle: 0xf520,
  arrow_up_arrow_down_circle_fill: 0xf521,
  arrow_up_arrow_down_square: 0xf522,
  arrow_up_arrow_down_square_fill: 0xf523,
  arrow_up_bin: 0xf524,
  arrow_up_bin_fill: 0xf525,
  arrow_up_circle: 0xf526,
  arrow_up_circle_fill: 0xf527,
  arrow_up_doc: 0xf528,
  arrow_up_doc_fill: 0xf529,
  arrow_up_down: 0xf52a,
  arrow_up_down_circle: 0xf52b,
  arrow_up_down_circle_fill: 0xf52c,
  arrow_up_down_square: 0xf52d,
  arrow_up_down_square_fill: 0xf52e,
  arrow_up_left: 0xf52f,
  arrow_up_left_arrow_down_right: 0xf386,
  arrow_up_left_circle: 0xf530,
  arrow_up_left_circle_fill: 0xf531,
  arrow_up_left_square: 0xf532,
  arrow_up_left_square_fill: 0xf533,
  arrow_up_right: 0xf534,
  arrow_up_right_circle: 0xf535,
  arrow_up_right_circle_fill: 0xf536,
  arrow_up_right_diamond: 0xf537,
  arrow_up_right_diamond_fill: 0xf538,
  arrow_up_right_square: 0xf539,
  arrow_up_right_square_fill: 0xf53a,
  arrow_up_square: 0xf53b,
  arrow_up_square_fill: 0xf53c,
  arrow_up_to_line: 0xf53d,
  arrow_up_to_line_alt: 0xf53e,
  arrow_uturn_down: 0xf53f,
  arrow_uturn_down_circle: 0xf540,
  arrow_uturn_down_circle_fill: 0xf541,
  arrow_uturn_down_square: 0xf542,
  arrow_uturn_down_square_fill: 0xf543,
  arrow_uturn_left: 0xf544,
  arrow_uturn_left_circle: 0xf545,
  arrow_uturn_left_circle_fill: 0xf546,
  arrow_uturn_left_square: 0xf547,
  arrow_uturn_left_square_fill: 0xf548,
  arrow_uturn_right: 0xf549,
  arrow_uturn_right_circle: 0xf54a,
  arrow_uturn_right_circle_fill: 0xf54b,
  arrow_uturn_right_square: 0xf54c,
  arrow_uturn_right_square_fill: 0xf54d,
  arrow_uturn_up: 0xf54e,
  arrow_uturn_up_circle: 0xf54f,
  arrow_uturn_up_circle_fill: 0xf550,
  arrow_uturn_up_square: 0xf551,
  arrow_uturn_up_square_fill: 0xf552,
  arrowshape_turn_up_left: 0xf4c6,
  arrowshape_turn_up_left_2: 0xf21d,
  arrowshape_turn_up_left_2_fill: 0xf21e,
  arrowshape_turn_up_left_circle: 0xf553,
  arrowshape_turn_up_left_circle_fill: 0xf554,
  arrowshape_turn_up_left_fill: 0xf555,
  arrowshape_turn_up_right: 0xf556,
  arrowshape_turn_up_right_circle: 0xf557,
  arrowshape_turn_up_right_circle_fill: 0xf558,
  arrowshape_turn_up_right_fill: 0xf559,
  arrowtriangle_down: 0xf55a,
  arrowtriangle_down_circle: 0xf55b,
  arrowtriangle_down_circle_fill: 0xf55c,
  arrowtriangle_down_fill: 0xf55d,
  arrowtriangle_down_square: 0xf55e,
  arrowtriangle_down_square_fill: 0xf55f,
  arrowtriangle_left: 0xf560,
  arrowtriangle_left_circle: 0xf561,
  arrowtriangle_left_circle_fill: 0xf562,
  arrowtriangle_left_fill: 0xf563,
  arrowtriangle_left_square: 0xf564,
  arrowtriangle_left_square_fill: 0xf565,
  arrowtriangle_right: 0xf566,
  arrowtriangle_right_circle: 0xf567,
  arrowtriangle_right_circle_fill: 0xf568,
  arrowtriangle_right_fill: 0xf569,
  arrowtriangle_right_square: 0xf56a,
  arrowtriangle_right_square_fill: 0xf56b,
  arrowtriangle_up: 0xf56c,
  arrowtriangle_up_circle: 0xf56d,
  arrowtriangle_up_circle_fill: 0xf56e,
  arrowtriangle_up_fill: 0xf56f,
  arrowtriangle_up_square: 0xf570,
  arrowtriangle_up_square_fill: 0xf571,
  asterisk_circle: 0xf572,
  asterisk_circle_fill: 0xf573,
  at: 0xf574,
  at_badge_minus: 0xf575,
  at_badge_plus: 0xf576,
  at_circle: 0xf8af,
  at_circle_fill: 0xf8b0,
  back: 0xf3cf,
  backward: 0xf577,
  backward_end: 0xf578,
  backward_end_alt: 0xf579,
  backward_end_alt_fill: 0xf57a,
  backward_end_fill: 0xf57b,
  backward_fill: 0xf57c,
  badge_plus_radiowaves_right: 0xf57d,
  bag: 0xf57e,
  bag_badge_minus: 0xf57f,
  bag_badge_plus: 0xf580,
  bag_fill: 0xf581,
  bag_fill_badge_minus: 0xf582,
  bag_fill_badge_plus: 0xf583,
  bandage: 0xf584,
  bandage_fill: 0xf585,
  barcode: 0xf586,
  barcode_viewfinder: 0xf587,
  bars: 0xf8b1,
  battery_0: 0xf112,
  battery_100: 0xf113,
  battery_25: 0xf115,
  battery_25_percent: 0xf115,
  battery_75_percent: 0xf114,
  battery_charging: 0xf111,
  battery_empty: 0xf112,
  battery_full: 0xf113,
  bed_double: 0xf588,
  bed_double_fill: 0xf589,
  bell: 0xf3e1,
  bell_circle: 0xf58a,
  bell_circle_fill: 0xf58b,
  bell_fill: 0xf3e2,
  bell_slash: 0xf58c,
  bell_slash_fill: 0xf58d,
  bell_solid: 0xf3e2,
  bin_xmark: 0xf58e,
  bin_xmark_fill: 0xf58f,
  bitcoin: 0xf8b2,
  bitcoin_circle: 0xf8b3,
  bitcoin_circle_fill: 0xf8b4,
  bluetooth: 0xf116,
  bold: 0xf590,
  bold_italic_underline: 0xf591,
  bold_underline: 0xf592,
  bolt: 0xf593,
  bolt_badge_a: 0xf594,
  bolt_badge_a_fill: 0xf595,
  bolt_circle: 0xf596,
  bolt_circle_fill: 0xf597,
  bolt_fill: 0xf598,
  bolt_horizontal: 0xf599,
  bolt_horizontal_circle: 0xf59a,
  bolt_horizontal_circle_fill: 0xf59b,
  bolt_horizontal_fill: 0xf59c,
  bolt_slash: 0xf59d,
  bolt_slash_fill: 0xf59e,
  book: 0xf3e7,
  book_circle: 0xf59f,
  book_circle_fill: 0xf5a0,
  book_fill: 0xf3e8,
  book_solid: 0xf3e8,
  bookmark: 0xf3e9,
  bookmark_fill: 0xf3ea,
  bookmark_solid: 0xf3ea,
  briefcase: 0xf5a1,
  briefcase_fill: 0xf5a2,
  brightness: 0xf4b6,
  brightness_solid: 0xf4b7,
  bubble_left: 0xf5a3,
  bubble_left_bubble_right: 0xf5a4,
  bubble_left_bubble_right_fill: 0xf5a5,
  bubble_left_fill: 0xf5a6,
  bubble_middle_bottom: 0xf5a7,
  bubble_middle_bottom_fill: 0xf5a8,
  bubble_middle_top: 0xf5a9,
  bubble_middle_top_fill: 0xf5aa,
  bubble_right: 0xf5ab,
  bubble_right_fill: 0xf5ac,
  building_2_fill: 0xf8b5,
  burn: 0xf5ad,
  burst: 0xf5ae,
  burst_fill: 0xf5af,
  bus: 0xf36d,
  calendar: 0xf5b0,
  calendar_badge_minus: 0xf5b1,
  calendar_badge_plus: 0xf5b2,
  calendar_circle: 0xf5b3,
  calendar_circle_fill: 0xf5b4,
  calendar_today: 0xf8b6,
  camera: 0xf3f5,
  camera_circle: 0xf5b5,
  camera_circle_fill: 0xf5b6,
  camera_fill: 0xf3f6,
  camera_on_rectangle: 0xf5b7,
  camera_on_rectangle_fill: 0xf5b8,
  camera_rotate: 0xf49e,
  camera_rotate_fill: 0xf49f,
  camera_viewfinder: 0xf5b9,
  capslock: 0xf5ba,
  capslock_fill: 0xf5bb,
  capsule: 0xf5bc,
  capsule_fill: 0xf5bd,
  captions_bubble: 0xf5be,
  captions_bubble_fill: 0xf5bf,
  car: 0xf36f,
  car_detailed: 0xf2c1,
  car_fill: 0xf36f,
  cart: 0xf3f7,
  cart_badge_minus: 0xf5c0,
  cart_badge_plus: 0xf5c1,
  cart_fill: 0xf5c2,
  cart_fill_badge_minus: 0xf5c3,
  cart_fill_badge_plus: 0xf5c4,
  chart_bar: 0xf5c5,
  chart_bar_alt_fill: 0xf8b7,
  chart_bar_circle: 0xf8b8,
  chart_bar_circle_fill: 0xf8b9,
  chart_bar_fill: 0xf5c6,
  chart_bar_square: 0xf8ba,
  chart_bar_square_fill: 0xf8bb,
  chart_pie: 0xf5c7,
  chart_pie_fill: 0xf5c8,
  chat_bubble: 0xf3fb,
  chat_bubble_2: 0xf8bc,
  chat_bubble_2_fill: 0xf8bd,
  chat_bubble_fill: 0xf8be,
  chat_bubble_text: 0xf8bf,
  chat_bubble_text_fill: 0xf8c0,
  check_mark: 0xf3fd,
  check_mark_circled: 0xf3fe,
  check_mark_circled_solid: 0xf3ff,
  checkmark: 0xf3fd,
  checkmark_alt: 0xf8c1,
  checkmark_alt_circle: 0xf8c2,
  checkmark_alt_circle_fill: 0xf8c3,
  checkmark_circle: 0xf3fe,
  checkmark_circle_fill: 0xf3ff,
  checkmark_rectangle: 0xf5c9,
  checkmark_rectangle_fill: 0xf5ca,
  checkmark_seal: 0xf5cb,
  checkmark_seal_fill: 0xf5cc,
  checkmark_shield: 0xf5cd,
  checkmark_shield_fill: 0xf5ce,
  checkmark_square: 0xf5cf,
  checkmark_square_fill: 0xf5d0,
  chevron_back: 0xf3cf,
  chevron_compact_down: 0xf5d1,
  chevron_compact_left: 0xf5d2,
  chevron_compact_right: 0xf5d3,
  chevron_compact_up: 0xf5d4,
  chevron_down: 0xf5d5,
  chevron_down_circle: 0xf5d6,
  chevron_down_circle_fill: 0xf5d7,
  chevron_down_square: 0xf5d8,
  chevron_down_square_fill: 0xf5d9,
  chevron_forward: 0xf3d1,
  chevron_left: 0xf3d2,
  chevron_left_2: 0xf5da,
  chevron_left_circle: 0xf5db,
  chevron_left_circle_fill: 0xf5dc,
  chevron_left_slash_chevron_right: 0xf5dd,
  chevron_left_square: 0xf5de,
  chevron_left_square_fill: 0xf5df,
  chevron_right: 0xf3d3,
  chevron_right_2: 0xf5e0,
  chevron_right_circle: 0xf5e1,
  chevron_right_circle_fill: 0xf5e2,
  chevron_right_square: 0xf5e3,
  chevron_right_square_fill: 0xf5e4,
  chevron_up: 0xf5e5,
  chevron_up_chevron_down: 0xf5e6,
  chevron_up_circle: 0xf5e7,
  chevron_up_circle_fill: 0xf5e8,
  chevron_up_square: 0xf5e9,
  chevron_up_square_fill: 0xf5ea,
  circle: 0xf401,
  circle_bottomthird_split: 0xf5eb,
  circle_fill: 0xf400,
  circle_filled: 0xf400,
  circle_grid_3x3: 0xf5ec,
  circle_grid_3x3_fill: 0xf5ed,
  circle_grid_hex: 0xf5ee,
  circle_grid_hex_fill: 0xf5ef,
  circle_lefthalf_fill: 0xf5f0,
  circle_righthalf_fill: 0xf5f1,
  clear: 0xf404,
  clear_circled: 0xf405,
  clear_circled_solid: 0xf406,
  clear_fill: 0xf5f3,
  clear_thick: 0xf2d7,
  clear_thick_circled: 0xf36e,
  clock: 0xf4be,
  clock_fill: 0xf403,
  clock_solid: 0xf4bf,
  cloud: 0xf5f4,
  cloud_bolt: 0xf5f5,
  cloud_bolt_fill: 0xf5f6,
  cloud_bolt_rain: 0xf5f7,
  cloud_bolt_rain_fill: 0xf5f8,
  cloud_download: 0xf8c4,
  cloud_download_fill: 0xf8c5,
  cloud_drizzle: 0xf5f9,
  cloud_drizzle_fill: 0xf5fa,
  cloud_fill: 0xf5fb,
  cloud_fog: 0xf5fc,
  cloud_fog_fill: 0xf5fd,
  cloud_hail: 0xf5fe,
  cloud_hail_fill: 0xf5ff,
  cloud_heavyrain: 0xf600,
  cloud_heavyrain_fill: 0xf601,
  cloud_moon: 0xf602,
  cloud_moon_bolt: 0xf603,
  cloud_moon_bolt_fill: 0xf604,
  cloud_moon_fill: 0xf605,
  cloud_moon_rain: 0xf606,
  cloud_moon_rain_fill: 0xf607,
  cloud_rain: 0xf608,
  cloud_rain_fill: 0xf609,
  cloud_sleet: 0xf60a,
  cloud_sleet_fill: 0xf60b,
  cloud_snow: 0xf60c,
  cloud_snow_fill: 0xf60d,
  cloud_sun: 0xf60e,
  cloud_sun_bolt: 0xf60f,
  cloud_sun_bolt_fill: 0xf610,
  cloud_sun_fill: 0xf611,
  cloud_sun_rain: 0xf612,
  cloud_sun_rain_fill: 0xf613,
  cloud_upload: 0xf8c6,
  cloud_upload_fill: 0xf8c7,
  collections: 0xf3c9,
  collections_solid: 0xf3ca,
  color_filter: 0xf8c8,
  color_filter_fill: 0xf8c9,
  command: 0xf614,
  compass: 0xf8ca,
  compass_fill: 0xf8cb,
  control: 0xf615,
  conversation_bubble: 0xf3fb,
  create: 0xf417,
  create_solid: 0xf417,
  creditcard: 0xf616,
  creditcard_fill: 0xf617,
  crop: 0xf618,
  crop_rotate: 0xf619,
  cube: 0xf61a,
  cube_box: 0xf61b,
  cube_box_fill: 0xf61c,
  cube_fill: 0xf61d,
  cursor_rays: 0xf61e,
  decrease_indent: 0xf61f,
  decrease_quotelevel: 0xf620,
  delete: 0xf4c4,
  delete_left: 0xf621,
  delete_left_fill: 0xf622,
  delete_right: 0xf623,
  delete_right_fill: 0xf624,
  delete_simple: 0xf37f,
  delete_solid: 0xf4c5,
  desktopcomputer: 0xf625,
  device_desktop: 0xf8cc,
  device_laptop: 0xf8cd,
  device_phone_landscape: 0xf8ce,
  device_phone_portrait: 0xf8cf,
  dial: 0xf626,
  dial_fill: 0xf627,
  divide: 0xf628,
  divide_circle: 0xf629,
  divide_circle_fill: 0xf62a,
  divide_square: 0xf62b,
  divide_square_fill: 0xf62c,
  doc: 0xf62d,
  doc_append: 0xf62e,
  doc_chart: 0xf8d0,
  doc_chart_fill: 0xf8d1,
  doc_checkmark: 0xf8d2,
  doc_checkmark_fill: 0xf8d3,
  doc_circle: 0xf62f,
  doc_circle_fill: 0xf630,
  doc_fill: 0xf631,
  doc_on_clipboard: 0xf632,
  doc_on_clipboard_fill: 0xf633,
  doc_on_doc: 0xf634,
  doc_on_doc_fill: 0xf635,
  doc_person: 0xf8d4,
  doc_person_fill: 0xf8d5,
  doc_plaintext: 0xf636,
  doc_richtext: 0xf637,
  doc_text: 0xf638,
  doc_text_fill: 0xf639,
  doc_text_search: 0xf63a,
  doc_text_viewfinder: 0xf63b,
  dot_radiowaves_left_right: 0xf63c,
  dot_radiowaves_right: 0xf63d,
  dot_square: 0xf63e,
  dot_square_fill: 0xf63f,
  double_music_note: 0xf46c,
  down_arrow: 0xf35d,
  download_circle: 0xf8d6,
  download_circle_fill: 0xf8d7,
  drop: 0xf8d8,
  drop_fill: 0xf8d9,
  drop_triangle: 0xf640,
  drop_triangle_fill: 0xf641,
  ear: 0xf642,
  eject: 0xf643,
  eject_fill: 0xf644,
  ellipses_bubble: 0xf645,
  ellipses_bubble_fill: 0xf646,
  ellipsis: 0xf46a,
  ellipsis_circle: 0xf647,
  ellipsis_circle_fill: 0xf648,
  ellipsis_vertical: 0xf8da,
  ellipsis_vertical_circle: 0xf8db,
  ellipsis_vertical_circle_fill: 0xf8dc,
  envelope: 0xf422,
  envelope_badge: 0xf649,
  envelope_badge_fill: 0xf64a,
  envelope_circle: 0xf64b,
  envelope_circle_fill: 0xf64c,
  envelope_fill: 0xf423,
  envelope_open: 0xf64d,
  envelope_open_fill: 0xf64e,
  equal: 0xf64f,
  equal_circle: 0xf650,
  equal_circle_fill: 0xf651,
  equal_square: 0xf652,
  equal_square_fill: 0xf653,
  escape: 0xf654,
  exclamationmark: 0xf655,
  exclamationmark_bubble: 0xf656,
  exclamationmark_bubble_fill: 0xf657,
  exclamationmark_circle: 0xf658,
  exclamationmark_circle_fill: 0xf659,
  exclamationmark_octagon: 0xf65a,
  exclamationmark_octagon_fill: 0xf65b,
  exclamationmark_shield: 0xf65c,
  exclamationmark_shield_fill: 0xf65d,
  exclamationmark_square: 0xf65e,
  exclamationmark_square_fill: 0xf65f,
  exclamationmark_triangle: 0xf660,
  exclamationmark_triangle_fill: 0xf661,
  eye: 0xf424,
  eye_fill: 0xf425,
  eye_slash: 0xf662,
  eye_slash_fill: 0xf663,
  eye_solid: 0xf425,
  eyedropper: 0xf664,
  eyedropper_full: 0xf665,
  eyedropper_halffull: 0xf666,
  eyeglasses: 0xf667,
  f_cursive: 0xf668,
  f_cursive_circle: 0xf669,
  f_cursive_circle_fill: 0xf66a,
  film: 0xf66b,
  film_fill: 0xf66c,
  flag: 0xf42c,
  flag_circle: 0xf66d,
  flag_circle_fill: 0xf66e,
  flag_fill: 0xf66f,
  flag_slash: 0xf670,
  flag_slash_fill: 0xf671,
  flame: 0xf672,
  flame_fill: 0xf673,
  floppy_disk: 0xf8dd,
  flowchart: 0xf674,
  flowchart_fill: 0xf675,
  folder: 0xf434,
  folder_badge_minus: 0xf676,
  folder_badge_person_crop: 0xf677,
  folder_badge_plus: 0xf678,
  folder_circle: 0xf679,
  folder_circle_fill: 0xf67a,
  folder_fill: 0xf435,
  folder_fill_badge_minus: 0xf67b,
  folder_fill_badge_person_crop: 0xf67c,
  folder_fill_badge_plus: 0xf67d,
  folder_open: 0xf38a,
  folder_solid: 0xf435,
  forward: 0xf3d1,
  forward_end: 0xf67f,
  forward_end_alt: 0xf680,
  forward_end_alt_fill: 0xf681,
  forward_end_fill: 0xf682,
  forward_fill: 0xf683,
  fullscreen: 0xf386,
  fullscreen_exit: 0xf37d,
  function: 0xf684,
  fx: 0xf685,
  game_controller: 0xf43a,
  game_controller_solid: 0xf43b,
  gamecontroller: 0xf43a,
  gamecontroller_alt_fill: 0xf8de,
  gamecontroller_fill: 0xf43b,
  gauge: 0xf686,
  gauge_badge_minus: 0xf687,
  gauge_badge_plus: 0xf688,
  gear: 0xf43c,
  gear_alt: 0xf43c,
  gear_alt_fill: 0xf43d,
  gear_big: 0xf2f7,
  gear_solid: 0xf43d,
  gift: 0xf689,
  gift_alt: 0xf68a,
  gift_alt_fill: 0xf68b,
  gift_fill: 0xf68c,
  globe: 0xf68d,
  gobackward: 0xf68e,
  gobackward_10: 0xf68f,
  gobackward_15: 0xf690,
  gobackward_30: 0xf691,
  gobackward_45: 0xf692,
  gobackward_60: 0xf693,
  gobackward_75: 0xf694,
  gobackward_90: 0xf695,
  gobackward_minus: 0xf696,
  goforward: 0xf697,
  goforward_10: 0xf698,
  goforward_15: 0xf699,
  goforward_30: 0xf69a,
  goforward_45: 0xf69b,
  goforward_60: 0xf69c,
  goforward_75: 0xf69d,
  goforward_90: 0xf69e,
  goforward_plus: 0xf69f,
  graph_circle: 0xf8df,
  graph_circle_fill: 0xf8e0,
  graph_square: 0xf8e1,
  graph_square_fill: 0xf8e2,
  greaterthan: 0xf6a0,
  greaterthan_circle: 0xf6a1,
  greaterthan_circle_fill: 0xf6a2,
  greaterthan_square: 0xf6a3,
  greaterthan_square_fill: 0xf6a4,
  grid: 0xf6a5,
  grid_circle: 0xf6a6,
  grid_circle_fill: 0xf6a7,
  group: 0xf47b,
  group_solid: 0xf47c,
  guitars: 0xf6a8,
  hammer: 0xf6a9,
  hammer_fill: 0xf6aa,
  hand_draw: 0xf6ab,
  hand_draw_fill: 0xf6ac,
  hand_point_left: 0xf6ad,
  hand_point_left_fill: 0xf6ae,
  hand_point_right: 0xf6af,
  hand_point_right_fill: 0xf6b0,
  hand_raised: 0xf6b1,
  hand_raised_fill: 0xf6b2,
  hand_raised_slash: 0xf6b3,
  hand_raised_slash_fill: 0xf6b4,
  hand_thumbsdown: 0xf6b5,
  hand_thumbsdown_fill: 0xf6b6,
  hand_thumbsup: 0xf6b7,
  hand_thumbsup_fill: 0xf6b8,
  hare: 0xf6b9,
  hare_fill: 0xf6ba,
  headphones: 0xf6bb,
  heart: 0xf442,
  heart_circle: 0xf6bc,
  heart_circle_fill: 0xf6bd,
  heart_fill: 0xf443,
  heart_slash: 0xf6be,
  heart_slash_circle: 0xf6bf,
  heart_slash_circle_fill: 0xf6c0,
  heart_slash_fill: 0xf6c1,
  heart_solid: 0xf443,
  helm: 0xf6c2,
  hexagon: 0xf6c3,
  hexagon_fill: 0xf6c4,
  hifispeaker: 0xf6c5,
  hifispeaker_fill: 0xf6c6,
  home: 0xf447,
  hourglass: 0xf6c7,
  hourglass_bottomhalf_fill: 0xf6c8,
  hourglass_tophalf_fill: 0xf6c9,
  house: 0xf447,
  house_alt: 0xf8e3,
  house_alt_fill: 0xf8e4,
  house_fill: 0xf6ca,
  hurricane: 0xf6cb,
  increase_indent: 0xf6cc,
  increase_quotelevel: 0xf6cd,
  infinite: 0xf449,
  info: 0xf44c,
  info_circle: 0xf44c,
  info_circle_fill: 0xf6cf,
  italic: 0xf6d0,
  keyboard: 0xf6d1,
  keyboard_chevron_compact_down: 0xf6d2,
  lab_flask: 0xf430,
  lab_flask_solid: 0xf431,
  largecircle_fill_circle: 0xf6d3,
  lasso: 0xf6d4,
  layers: 0xf8e5,
  layers_alt: 0xf8e6,
  layers_alt_fill: 0xf8e7,
  layers_fill: 0xf8e8,
  leaf_arrow_circlepath: 0xf6d5,
  left_chevron: 0xf3d2,
  lessthan: 0xf6d6,
  lessthan_circle: 0xf6d7,
  lessthan_circle_fill: 0xf6d8,
  lessthan_square: 0xf6d9,
  lessthan_square_fill: 0xf6da,
  light_max: 0xf6db,
  light_min: 0xf6dc,
  lightbulb: 0xf6dd,
  lightbulb_fill: 0xf6de,
  lightbulb_slash: 0xf6df,
  lightbulb_slash_fill: 0xf6e0,
  line_horizontal_3: 0xf6e1,
  line_horizontal_3_decrease: 0xf6e2,
  line_horizontal_3_decrease_circle: 0xf6e3,
  line_horizontal_3_decrease_circle_fill: 0xf6e4,
  link: 0xf6e5,
  link_circle: 0xf6e6,
  link_circle_fill: 0xf6e7,
  list_bullet: 0xf6e8,
  list_bullet_below_rectangle: 0xf6e9,
  list_bullet_indent: 0xf6ea,
  list_dash: 0xf6eb,
  list_number: 0xf6ec,
  list_number_rtl: 0xf6ed,
  location: 0xf6ee,
  location_circle: 0xf6ef,
  location_circle_fill: 0xf6f0,
  location_fill: 0xf6f1,
  location_north: 0xf6f2,
  location_north_fill: 0xf6f3,
  location_north_line: 0xf6f4,
  location_north_line_fill: 0xf6f5,
  location_slash: 0xf6f6,
  location_slash_fill: 0xf6f7,
  location_solid: 0xf456,
  lock: 0xf4c8,
  lock_circle: 0xf6f8,
  lock_circle_fill: 0xf6f9,
  lock_fill: 0xf4c9,
  lock_open: 0xf6fa,
  lock_open_fill: 0xf6fb,
  lock_rotation: 0xf6fc,
  lock_rotation_open: 0xf6fd,
  lock_shield: 0xf6fe,
  lock_shield_fill: 0xf6ff,
  lock_slash: 0xf700,
  lock_slash_fill: 0xf701,
  loop: 0xf449,
  loop_thick: 0xf44a,
  macwindow: 0xf702,
  mail: 0xf422,
  mail_solid: 0xf423,
  map: 0xf703,
  map_fill: 0xf704,
  map_pin: 0xf705,
  map_pin_ellipse: 0xf706,
  map_pin_slash: 0xf707,
  memories: 0xf708,
  memories_badge_minus: 0xf709,
  memories_badge_plus: 0xf70a,
  metronome: 0xf70b,
  mic: 0xf460,
  mic_circle: 0xf70c,
  mic_circle_fill: 0xf70d,
  mic_fill: 0xf461,
  mic_off: 0xf45f,
  mic_slash: 0xf45f,
  mic_slash_fill: 0xf70e,
  mic_solid: 0xf461,
  minus: 0xf70f,
  minus_circle: 0xf463,
  minus_circle_fill: 0xf710,
  minus_circled: 0xf463,
  minus_rectangle: 0xf711,
  minus_rectangle_fill: 0xf712,
  minus_slash_plus: 0xf713,
  minus_square: 0xf714,
  minus_square_fill: 0xf715,
  money_dollar: 0xf8e9,
  money_dollar_circle: 0xf8ea,
  money_dollar_circle_fill: 0xf8eb,
  money_euro: 0xf8ec,
  money_euro_circle: 0xf8ed,
  money_euro_circle_fill: 0xf8ee,
  money_pound: 0xf8ef,
  money_pound_circle: 0xf8f0,
  money_pound_circle_fill: 0xf8f1,
  money_rubl: 0xf8f2,
  money_rubl_circle: 0xf8f3,
  money_rubl_circle_fill: 0xf8f4,
  money_yen: 0xf8f5,
  money_yen_circle: 0xf8f6,
  money_yen_circle_fill: 0xf8f7,
  moon: 0xf716,
  moon_circle: 0xf717,
  moon_circle_fill: 0xf718,
  moon_fill: 0xf719,
  moon_stars: 0xf71a,
  moon_stars_fill: 0xf71b,
  moon_zzz: 0xf71c,
  moon_zzz_fill: 0xf71d,
  move: 0xf8f8,
  multiply: 0xf71e,
  multiply_circle: 0xf71f,
  multiply_circle_fill: 0xf720,
  multiply_square: 0xf721,
  multiply_square_fill: 0xf722,
  music_albums: 0xf8f9,
  music_albums_fill: 0xf8fa,
  music_house: 0xf723,
  music_house_fill: 0xf724,
  music_mic: 0xf725,
  music_note: 0xf46b,
  music_note_2: 0xf46c,
  music_note_list: 0xf726,
  news: 0xf471,
  news_solid: 0xf472,
  nosign: 0xf727,
  number: 0xf728,
  number_circle: 0xf729,
  number_circle_fill: 0xf72a,
  number_square: 0xf72b,
  number_square_fill: 0xf72c,
  option: 0xf72d,
  padlock: 0xf4c8,
  padlock_solid: 0xf4c9,
  paintbrush: 0xf72e,
  paintbrush_fill: 0xf72f,
  pano: 0xf730,
  pano_fill: 0xf731,
  paperclip: 0xf732,
  paperplane: 0xf733,
  paperplane_fill: 0xf734,
  paragraph: 0xf735,
  pause: 0xf477,
  pause_circle: 0xf736,
  pause_circle_fill: 0xf737,
  pause_fill: 0xf478,
  pause_rectangle: 0xf738,
  pause_rectangle_fill: 0xf739,
  pause_solid: 0xf478,
  paw: 0xf479,
  paw_solid: 0xf47a,
  pen: 0xf2bf,
  pencil: 0xf37e,
  pencil_circle: 0xf73a,
  pencil_circle_fill: 0xf73b,
  pencil_ellipsis_rectangle: 0xf73c,
  pencil_outline: 0xf73d,
  pencil_slash: 0xf73e,
  percent: 0xf73f,
  person: 0xf47d,
  person_2: 0xf740,
  person_2_alt: 0xf8fb,
  person_2_fill: 0xf741,
  person_2_square_stack: 0xf742,
  person_2_square_stack_fill: 0xf743,
  person_3: 0xf47b,
  person_3_fill: 0xf47c,
  person_add: 0xf47f,
  person_add_solid: 0xf480,
  person_alt: 0xf8fc,
  person_alt_circle: 0xf8fd,
  person_alt_circle_fill: 0xf8fe,
  person_badge_minus: 0xf744,
  person_badge_minus_fill: 0xf745,
  person_badge_plus: 0xf47f,
  person_badge_plus_fill: 0xf480,
  person_circle: 0xf746,
  person_circle_fill: 0xf747,
  person_crop_circle: 0xf419,
  person_crop_circle_badge_checkmark: 0xf748,
  person_crop_circle_badge_exclam: 0xf749,
  person_crop_circle_badge_minus: 0xf74a,
  person_crop_circle_badge_plus: 0xf74b,
  person_crop_circle_badge_xmark: 0xf74c,
  person_crop_circle_fill: 0xf74d,
  person_crop_circle_fill_badge_checkmark: 0xf74e,
  person_crop_circle_fill_badge_exclam: 0xf74f,
  person_crop_circle_fill_badge_minus: 0xf750,
  person_crop_circle_fill_badge_plus: 0xf751,
  person_crop_circle_fill_badge_xmark: 0xf752,
  person_crop_rectangle: 0xf753,
  person_crop_rectangle_fill: 0xf754,
  person_crop_square: 0xf755,
  person_crop_square_fill: 0xf756,
  person_fill: 0xf47e,
  person_solid: 0xf47e,
  personalhotspot: 0xf757,
  perspective: 0xf758,
  phone: 0xf4b8,
  phone_arrow_down_left: 0xf759,
  phone_arrow_right: 0xf75a,
  phone_arrow_up_right: 0xf75b,
  phone_badge_plus: 0xf75c,
  phone_circle: 0xf75d,
  phone_circle_fill: 0xf75e,
  phone_down: 0xf75f,
  phone_down_circle: 0xf760,
  phone_down_circle_fill: 0xf761,
  phone_down_fill: 0xf762,
  phone_fill: 0xf4b9,
  phone_fill_arrow_down_left: 0xf763,
  phone_fill_arrow_right: 0xf764,
  phone_fill_arrow_up_right: 0xf765,
  phone_fill_badge_plus: 0xf766,
  phone_solid: 0xf4b9,
  photo: 0xf767,
  photo_camera: 0xf3f5,
  photo_camera_solid: 0xf3f6,
  photo_fill: 0xf768,
  photo_fill_on_rectangle_fill: 0xf769,
  photo_on_rectangle: 0xf76a,
  piano: 0xf8ff,
  pin: 0xf76b,
  pin_fill: 0xf76c,
  pin_slash: 0xf76d,
  pin_slash_fill: 0xf76e,
  placemark: 0xf455,
  placemark_fill: 0xf456,
  play: 0xf487,
  play_arrow: 0xf487,
  play_arrow_solid: 0xf488,
  play_circle: 0xf76f,
  play_circle_fill: 0xf770,
  play_fill: 0xf488,
  play_rectangle: 0xf771,
  play_rectangle_fill: 0xf772,
  playpause: 0xf773,
  playpause_fill: 0xf774,
  plus: 0xf489,
  plus_app: 0xf775,
  plus_app_fill: 0xf776,
  plus_bubble: 0xf777,
  plus_bubble_fill: 0xf778,
  plus_circle: 0xf48a,
  plus_circle_fill: 0xf48b,
  plus_circled: 0xf48a,
  plus_rectangle: 0xf779,
  plus_rectangle_fill: 0xf77a,
  plus_rectangle_fill_on_rectangle_fill: 0xf77b,
  plus_rectangle_on_rectangle: 0xf77c,
  plus_slash_minus: 0xf77d,
  plus_square: 0xf77e,
  plus_square_fill: 0xf77f,
  plus_square_fill_on_square_fill: 0xf780,
  plus_square_on_square: 0xf781,
  plusminus: 0xf782,
  plusminus_circle: 0xf783,
  plusminus_circle_fill: 0xf784,
  power: 0xf785,
  printer: 0xf786,
  printer_fill: 0xf787,
  profile_circled: 0xf419,
  projective: 0xf788,
  purchased: 0xf789,
  purchased_circle: 0xf78a,
  purchased_circle_fill: 0xf78b,
  qrcode: 0xf78c,
  qrcode_viewfinder: 0xf78d,
  question: 0xf78e,
  question_circle: 0xf78f,
  question_circle_fill: 0xf790,
  question_diamond: 0xf791,
  question_diamond_fill: 0xf792,
  question_square: 0xf793,
  question_square_fill: 0xf794,
  quote_bubble: 0xf795,
  quote_bubble_fill: 0xf796,
  radiowaves_left: 0xf797,
  radiowaves_right: 0xf798,
  rays: 0xf799,
  recordingtape: 0xf79a,
  rectangle: 0xf79b,
  rectangle_3_offgrid: 0xf79c,
  rectangle_3_offgrid_fill: 0xf79d,
  rectangle_arrow_up_right_arrow_down_left: 0xf79e,
  rectangle_arrow_up_right_arrow_down_left_slash: 0xf79f,
  rectangle_badge_checkmark: 0xf7a0,
  rectangle_badge_xmark: 0xf7a1,
  rectangle_compress_vertical: 0xf7a2,
  rectangle_dock: 0xf7a3,
  rectangle_expand_vertical: 0xf7a4,
  rectangle_fill: 0xf7a5,
  rectangle_fill_badge_checkmark: 0xf7a6,
  rectangle_fill_badge_xmark: 0xf7a7,
  rectangle_fill_on_rectangle_angled_fill: 0xf7a8,
  rectangle_fill_on_rectangle_fill: 0xf7a9,
  rectangle_grid_1x2: 0xf7aa,
  rectangle_grid_1x2_fill: 0xf7ab,
  rectangle_grid_2x2: 0xf7ac,
  rectangle_grid_2x2_fill: 0xf7ad,
  rectangle_grid_3x2: 0xf7ae,
  rectangle_grid_3x2_fill: 0xf7af,
  rectangle_on_rectangle: 0xf7b0,
  rectangle_on_rectangle_angled: 0xf7b1,
  rectangle_paperclip: 0xf7b2,
  rectangle_split_3x1: 0xf7b3,
  rectangle_split_3x1_fill: 0xf7b4,
  rectangle_split_3x3: 0xf7b5,
  rectangle_split_3x3_fill: 0xf7b6,
  rectangle_stack: 0xf3c9,
  rectangle_stack_badge_minus: 0xf7b7,
  rectangle_stack_badge_person_crop: 0xf7b8,
  rectangle_stack_badge_plus: 0xf7b9,
  rectangle_stack_fill: 0xf3ca,
  rectangle_stack_fill_badge_minus: 0xf7ba,
  rectangle_stack_fill_badge_person_crop: 0xf7bb,
  rectangle_stack_fill_badge_plus: 0xf7bc,
  rectangle_stack_person_crop: 0xf7bd,
  rectangle_stack_person_crop_fill: 0xf7be,
  refresh: 0xf49a,
  refresh_bold: 0xf21c,
  refresh_circled: 0xf49b,
  refresh_circled_solid: 0xf49c,
  refresh_thick: 0xf3a8,
  refresh_thin: 0xf49d,
  repeat: 0xf7bf,
  repeat_1: 0xf7c0,
  reply: 0xf4c6,
  reply_all: 0xf21d,
  reply_thick_solid: 0xf21e,
  resize: 0xf900,
  resize_h: 0xf901,
  resize_v: 0xf902,
  restart: 0xf21c,
  return_icon: 0xf7c1,
  rhombus: 0xf7c2,
  rhombus_fill: 0xf7c3,
  right_chevron: 0xf3d3,
  rocket: 0xf903,
  rocket_fill: 0xf904,
  rosette: 0xf7c4,
  rotate_left: 0xf7c5,
  rotate_left_fill: 0xf7c6,
  rotate_right: 0xf7c7,
  rotate_right_fill: 0xf7c8,
  scissors: 0xf7c9,
  scissors_alt: 0xf905,
  scope: 0xf7ca,
  scribble: 0xf7cb,
  search: 0xf4a5,
  search_circle: 0xf7cc,
  search_circle_fill: 0xf7cd,
  selection_pin_in_out: 0xf7ce,
  settings: 0xf411,
  settings_solid: 0xf412,
  share: 0xf4ca,
  share_solid: 0xf4cb,
  share_up: 0xf220,
  shield: 0xf7cf,
  shield_fill: 0xf7d0,
  shield_lefthalf_fill: 0xf7d1,
  shield_slash: 0xf7d2,
  shield_slash_fill: 0xf7d3,
  shift: 0xf7d4,
  shift_fill: 0xf7d5,
  shopping_cart: 0xf3f7,
  shuffle: 0xf4a9,
  shuffle_medium: 0xf4a8,
  shuffle_thick: 0xf221,
  sidebar_left: 0xf7d6,
  sidebar_right: 0xf7d7,
  signature: 0xf7d8,
  skew: 0xf7d9,
  slash_circle: 0xf7da,
  slash_circle_fill: 0xf7db,
  slider_horizontal_3: 0xf7dc,
  slider_horizontal_below_rectangle: 0xf7dd,
  slowmo: 0xf7de,
  smallcircle_circle: 0xf7df,
  smallcircle_circle_fill: 0xf7e0,
  smallcircle_fill_circle: 0xf7e1,
  smallcircle_fill_circle_fill: 0xf7e2,
  smiley: 0xf7e3,
  smiley_fill: 0xf7e4,
  smoke: 0xf7e5,
  smoke_fill: 0xf7e6,
  snow: 0xf7e7,
  sort_down: 0xf906,
  sort_down_circle: 0xf907,
  sort_down_circle_fill: 0xf908,
  sort_up: 0xf909,
  sort_up_circle: 0xf90a,
  sort_up_circle_fill: 0xf90b,
  sparkles: 0xf7e8,
  speaker: 0xf7e9,
  speaker_1: 0xf7ea,
  speaker_1_fill: 0xf3b7,
  speaker_2: 0xf7eb,
  speaker_2_fill: 0xf7ec,
  speaker_3: 0xf7ed,
  speaker_3_fill: 0xf3ba,
  speaker_fill: 0xf3b8,
  speaker_slash: 0xf7ee,
  speaker_slash_fill: 0xf3b9,
  speaker_slash_fill_rtl: 0xf7ef,
  speaker_slash_rtl: 0xf7f0,
  speaker_zzz: 0xf7f1,
  speaker_zzz_fill: 0xf7f2,
  speaker_zzz_fill_rtl: 0xf7f3,
  speaker_zzz_rtl: 0xf7f4,
  speedometer: 0xf7f5,
  sportscourt: 0xf7f6,
  sportscourt_fill: 0xf7f7,
  square: 0xf7f8,
  square_arrow_down: 0xf7f9,
  square_arrow_down_fill: 0xf7fa,
  square_arrow_down_on_square: 0xf7fb,
  square_arrow_down_on_square_fill: 0xf7fc,
  square_arrow_left: 0xf90c,
  square_arrow_left_fill: 0xf90d,
  square_arrow_right: 0xf90e,
  square_arrow_right_fill: 0xf90f,
  square_arrow_up: 0xf4ca,
  square_arrow_up_fill: 0xf4cb,
  square_arrow_up_on_square: 0xf7fd,
  square_arrow_up_on_square_fill: 0xf7fe,
  square_favorites: 0xf910,
  square_favorites_alt: 0xf911,
  square_favorites_alt_fill: 0xf912,
  square_favorites_fill: 0xf913,
  square_fill: 0xf7ff,
  square_fill_line_vertical_square: 0xf800,
  square_fill_line_vertical_square_fill: 0xf801,
  square_fill_on_circle_fill: 0xf802,
  square_fill_on_square_fill: 0xf803,
  square_grid_2x2: 0xf804,
  square_grid_2x2_fill: 0xf805,
  square_grid_3x2: 0xf806,
  square_grid_3x2_fill: 0xf807,
  square_grid_4x3_fill: 0xf808,
  square_lefthalf_fill: 0xf809,
  square_line_vertical_square: 0xf80a,
  square_line_vertical_square_fill: 0xf80b,
  square_list: 0xf914,
  square_list_fill: 0xf915,
  square_on_circle: 0xf80c,
  square_on_square: 0xf80d,
  square_pencil: 0xf417,
  square_pencil_fill: 0xf417,
  square_righthalf_fill: 0xf80e,
  square_split_1x2: 0xf80f,
  square_split_1x2_fill: 0xf810,
  square_split_2x1: 0xf811,
  square_split_2x1_fill: 0xf812,
  square_split_2x2: 0xf813,
  square_split_2x2_fill: 0xf814,
  square_stack: 0xf815,
  square_stack_3d_down_dottedline: 0xf816,
  square_stack_3d_down_right: 0xf817,
  square_stack_3d_down_right_fill: 0xf818,
  square_stack_3d_up: 0xf819,
  square_stack_3d_up_fill: 0xf81a,
  square_stack_3d_up_slash: 0xf81b,
  square_stack_3d_up_slash_fill: 0xf81c,
  square_stack_fill: 0xf81d,
  squares_below_rectangle: 0xf81e,
  star: 0xf81f,
  star_circle: 0xf820,
  star_circle_fill: 0xf821,
  star_fill: 0xf822,
  star_lefthalf_fill: 0xf823,
  star_slash: 0xf824,
  star_slash_fill: 0xf825,
  staroflife: 0xf826,
  staroflife_fill: 0xf827,
  stop: 0xf828,
  stop_circle: 0xf829,
  stop_circle_fill: 0xf82a,
  stop_fill: 0xf82b,
  stopwatch: 0xf82c,
  stopwatch_fill: 0xf82d,
  strikethrough: 0xf82e,
  suit_club: 0xf82f,
  suit_club_fill: 0xf830,
  suit_diamond: 0xf831,
  suit_diamond_fill: 0xf832,
  suit_heart: 0xf833,
  suit_heart_fill: 0xf834,
  suit_spade: 0xf835,
  suit_spade_fill: 0xf836,
  sum: 0xf837,
  sun_dust: 0xf838,
  sun_dust_fill: 0xf839,
  sun_haze: 0xf83a,
  sun_haze_fill: 0xf83b,
  sun_max: 0xf4b6,
  sun_max_fill: 0xf4b7,
  sun_min: 0xf83c,
  sun_min_fill: 0xf83d,
  sunrise: 0xf83e,
  sunrise_fill: 0xf83f,
  sunset: 0xf840,
  sunset_fill: 0xf841,
  switch_camera: 0xf49e,
  switch_camera_solid: 0xf49f,
  t_bubble: 0xf842,
  t_bubble_fill: 0xf843,
  table: 0xf844,
  table_badge_more: 0xf845,
  table_badge_more_fill: 0xf846,
  table_fill: 0xf847,
  tag: 0xf48c,
  tag_circle: 0xf848,
  tag_circle_fill: 0xf849,
  tag_fill: 0xf48d,
  tag_solid: 0xf48d,
  tags: 0xf48e,
  tags_solid: 0xf48f,
  text_aligncenter: 0xf84a,
  text_alignleft: 0xf84b,
  text_alignright: 0xf84c,
  text_append: 0xf84d,
  text_badge_checkmark: 0xf84e,
  text_badge_minus: 0xf84f,
  text_badge_plus: 0xf850,
  text_badge_star: 0xf851,
  text_badge_xmark: 0xf852,
  text_bubble: 0xf853,
  text_bubble_fill: 0xf854,
  text_cursor: 0xf855,
  text_insert: 0xf856,
  text_justify: 0xf857,
  text_justifyleft: 0xf858,
  text_justifyright: 0xf859,
  text_quote: 0xf85a,
  textbox: 0xf85b,
  textformat: 0xf85c,
  textformat_123: 0xf85d,
  textformat_abc: 0xf85e,
  textformat_abc_dottedunderline: 0xf85f,
  textformat_alt: 0xf860,
  textformat_size: 0xf861,
  textformat_subscript: 0xf862,
  textformat_superscript: 0xf863,
  thermometer: 0xf864,
  thermometer_snowflake: 0xf865,
  thermometer_sun: 0xf866,
  ticket: 0xf916,
  ticket_fill: 0xf917,
  tickets: 0xf918,
  tickets_fill: 0xf919,
  time: 0xf402,
  time_solid: 0xf403,
  timelapse: 0xf867,
  timer: 0xf868,
  timer_fill: 0xf91a,
  today: 0xf91b,
  today_fill: 0xf91c,
  tornado: 0xf869,
  tortoise: 0xf86a,
  tortoise_fill: 0xf86b,
  train_style_one: 0xf3af,
  train_style_two: 0xf3b4,
  tram_fill: 0xf86c,
  trash: 0xf4c4,
  trash_circle: 0xf86d,
  trash_circle_fill: 0xf86e,
  trash_fill: 0xf4c5,
  trash_slash: 0xf86f,
  trash_slash_fill: 0xf870,
  tray: 0xf871,
  tray_2: 0xf872,
  tray_2_fill: 0xf873,
  tray_arrow_down: 0xf874,
  tray_arrow_down_fill: 0xf875,
  tray_arrow_up: 0xf876,
  tray_arrow_up_fill: 0xf877,
  tray_fill: 0xf878,
  tray_full: 0xf879,
  tray_full_fill: 0xf87a,
  tree: 0xf91d,
  triangle: 0xf87b,
  triangle_fill: 0xf87c,
  triangle_lefthalf_fill: 0xf87d,
  triangle_righthalf_fill: 0xf87e,
  tropicalstorm: 0xf87f,
  tuningfork: 0xf880,
  tv: 0xf881,
  tv_circle: 0xf882,
  tv_circle_fill: 0xf883,
  tv_fill: 0xf884,
  tv_music_note: 0xf885,
  tv_music_note_fill: 0xf886,
  uiwindow_split_2x1: 0xf887,
  umbrella: 0xf888,
  umbrella_fill: 0xf889,
  underline: 0xf88a,
  up_arrow: 0xf366,
  upload_circle: 0xf91e,
  upload_circle_fill: 0xf91f,
  video_camera: 0xf4cc,
  video_camera_solid: 0xf4cd,
  videocam: 0xf4cc,
  videocam_circle: 0xf920,
  videocam_circle_fill: 0xf921,
  videocam_fill: 0xf4cd,
  view_2d: 0xf88b,
  view_3d: 0xf88c,
  viewfinder: 0xf88d,
  viewfinder_circle: 0xf88e,
  viewfinder_circle_fill: 0xf88f,
  volume_down: 0xf3b7,
  volume_mute: 0xf3b8,
  volume_off: 0xf3b9,
  volume_up: 0xf3ba,
  wand_rays: 0xf890,
  wand_rays_inverse: 0xf891,
  wand_stars: 0xf892,
  wand_stars_inverse: 0xf893,
  waveform: 0xf894,
  waveform_circle: 0xf895,
  waveform_circle_fill: 0xf896,
  waveform_path: 0xf897,
  waveform_path_badge_minus: 0xf898,
  waveform_path_badge_plus: 0xf899,
  waveform_path_ecg: 0xf89a,
  wifi: 0xf89b,
  wifi_exclamationmark: 0xf89c,
  wifi_slash: 0xf89d,
  wind: 0xf89e,
  wind_snow: 0xf89f,
  wrench: 0xf8a0,
  wrench_fill: 0xf8a1,
  xmark: 0xf404,
  xmark_circle: 0xf405,
  xmark_circle_fill: 0xf36e,
  xmark_octagon: 0xf8a2,
  xmark_octagon_fill: 0xf8a3,
  xmark_rectangle: 0xf8a4,
  xmark_rectangle_fill: 0xf8a5,
  xmark_seal: 0xf8a6,
  xmark_seal_fill: 0xf8a7,
  xmark_shield: 0xf8a8,
  xmark_shield_fill: 0xf8a9,
  xmark_square: 0xf8aa,
  xmark_square_fill: 0xf8ab,
  zoom_in: 0xf8ac,
  zoom_out: 0xf8ad,
  zzz: 0xf8ae,
} as const;

export type CupertinoIconName = keyof typeof CUPERTINO_CODEPOINTS;
